import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { api, imgSrc } from "@/lib/api";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";

export default function Cookbook() {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  const cover = settings.cookbook_cover || "/assets/cookbook.jpg";

  return (
    <div data-testid="cookbook-page">
      <PageHero eyebrow="The Cookbook" title="Poolside Cooking, in your kitchen." sub="Recipes, stories, and flavors from the show — by Jemmalyn Hewlett." />

      <section className="py-16 sm:py-20 bg-cream">
        <div className="container-site grid lg:grid-cols-12 gap-14 items-center">
          <Reveal className="lg:col-span-5">
            <div className="max-w-sm mx-auto -rotate-2 hover:rotate-0 transition-transform duration-500">
              <img
                src={imgSrc(cover)}
                alt="Poolside Cooking — More Than Just a Cookbook; It's a Lifestyle! by Jemmalyn Hewlett"
                className="w-full rounded-lg shadow-[0_40px_80px_rgba(2,20,30,0.3)]"
                data-testid="cookbook-cover"
              />
            </div>
          </Reveal>
          <Reveal className="lg:col-span-7" delay={0.15}>
            <p className="label-eyebrow mb-5">By Jemmalyn Hewlett</p>
            <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight text-slate-900 leading-[1.0]">
              More Than Just a Cookbook;<br />
              <span className="text-pool">It's a Lifestyle.</span>
            </h2>
            <p className="mt-8 text-slate-600 text-base sm:text-lg leading-relaxed max-w-xl">
              Bring the Poolside experience home with recipes, stories, and flavors from Poolside Cooking. Every
              page is an invitation to cook, connect, and create memories.
            </p>
            <div className="mt-10 flex flex-wrap gap-4">
              {settings.cookbook_amazon ? (
                <a href={settings.cookbook_amazon} target="_blank" rel="noreferrer" data-testid="shop-amazon" className="inline-flex items-center gap-3 bg-slate-950 hover:bg-pool text-white font-bold text-xs sm:text-sm tracking-[0.15em] uppercase px-8 py-4 rounded-full transition-colors">
                  Shop on Amazon <ArrowUpRight className="h-4 w-4" />
                </a>
              ) : (
                <span data-testid="shop-amazon" className="inline-flex items-center gap-3 bg-slate-950/40 text-white font-bold text-xs sm:text-sm tracking-[0.15em] uppercase px-8 py-4 rounded-full cursor-not-allowed">
                  Shop on Amazon — link soon
                </span>
              )}
              {settings.cookbook_bn ? (
                <a href={settings.cookbook_bn} target="_blank" rel="noreferrer" data-testid="shop-bn" className="inline-flex items-center gap-3 border border-slate-900 text-slate-900 hover:bg-slate-900 hover:text-white font-bold text-xs sm:text-sm tracking-[0.15em] uppercase px-8 py-4 rounded-full transition-colors">
                  Shop at Barnes &amp; Noble <ArrowUpRight className="h-4 w-4" />
                </a>
              ) : (
                <span data-testid="shop-bn" className="inline-flex items-center gap-3 border border-slate-300 text-slate-400 font-bold text-xs sm:text-sm tracking-[0.15em] uppercase px-8 py-4 rounded-full cursor-not-allowed">
                  Barnes &amp; Noble — link soon
                </span>
              )}
            </div>
            <p className="mt-12 font-script text-3xl sm:text-4xl text-slate-700">Cook. Connect. Create Memories.</p>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
